module.exports = __webpack_public_path__ + "img/pr-9.a7e9d0a4.png";